import { IUserProfile } from "@livelike/javascript";
import { create } from "zustand";

import { ISoccerMatch } from "../../../types";

export type AppStoreValue = {
  profile?: IUserProfile;
  matchData?: ISoccerMatch;
  showBoxScoreOnTop: boolean;
  hasMultipleLiveMatches: boolean;
};

type AppStoreActions = {
  updateUserProfile: (profile: IUserProfile) => void;
  updateMatchData: (matchData: ISoccerMatch) => void;
  setShowBoxScoreOnTop: (showBoxScoreOnTop: boolean) => void;
  setHasMultipleLiveMatches: (hasMultipleLiveMatches: boolean) => void;
};

export const useAppStore = create<AppStoreValue & AppStoreActions>((set) => ({
  // states
  showBoxScoreOnTop: false,
  hasMultipleLiveMatches: false,
  // Actions
  updateUserProfile: (profile) => set((state) => ({ ...state, profile })),
  updateMatchData: (matchData) => set((state) => ({ ...state, matchData })),
  setShowBoxScoreOnTop: (showBoxScoreOnTop) =>
    set((state) => ({ ...state, showBoxScoreOnTop })),
  setHasMultipleLiveMatches: (hasMultipleLiveMatches) =>
    set((state) => ({ ...state, hasMultipleLiveMatches })),
}));

export const appController = {
  getState: <T extends keyof AppStoreValue>(key: T) =>
    useAppStore.getState()[key],
  updateUserProfile: (profile: IUserProfile) =>
    useAppStore.getState().updateUserProfile(profile),
  updateMatchData: (matchData: ISoccerMatch) =>
    useAppStore.getState().updateMatchData(matchData),
};
